import React, { useState } from 'react';
import ModalComponent from '../../../common/ModalComponent/ModalComponent';
import UsageRightDetail from './UsageRightDetail';
import UsageRightRevision from './UsageRightRevision';
import { UsageRightRequest } from '../types';

interface UsageRightModalProps {
  open: boolean;
  onClose: () => unknown;
  request: UsageRightRequest | null;
}

function UsageRightModal({ onClose, open, request }: UsageRightModalProps) {
  const [usageRightRevisionOpen, setUsageRightRevisionOpen] = useState(false);

  if (!request) return null;

  return (
    <ModalComponent
      style={{ padding: 0, maxHeight: '100%' }}
      content={{ maxHeight: '100%' }}
      open={open}
      onClose={() => {
        window.history.replaceState({}, '');
        setUsageRightRevisionOpen(false);
        onClose();
      }}
    >
      {usageRightRevisionOpen ? (
        <UsageRightRevision request={request} onClose={onClose} />
      ) : (
        <UsageRightDetail setUsageRightRevisionOpen={setUsageRightRevisionOpen} request={request} onClose={onClose} />
      )}
    </ModalComponent>
  );
}

export default UsageRightModal;
